import {
    AUTH_SUBMIT_SAGA,
    CHECK_TOKEN_SAGA,
    CURRENT_VISITORS_SAGA,
    ESTABLISHMENT_LIST_SAGA,
    CLOSE_WORKOUT_SAGA,
    GET_STATISTIC_SAGA,
    GET_SUBSCRIPTIONS_SAGA,
    UPDATE_SUBSCRIPTION_SAGA,
    UPDATE_USER_SAGA,
    REMOVE_USER_SAGA,
    GET_USERS_FOR_SUBSCRIPTION_FORM_SAGA,
    GET_SUBSCRIPTION_DATA,
    ADD_SUBSCRIPTION_SAGA,
    UPDATE_ESTABLISHMENT_SAGA,
    UPDATE_SUBSCRIPTION_TYPE_SAGA,
    UPDATE_SUBSCRIPTION_DURATION_SAGA,
    UPDATE_SUBSCRIPTION_WORKOUTS_SAGA,
    UPDATE_SUBSCRIPTION_CONSTRAINT_SAGA,
    GET_SUBSCRIPTION_TYPE_SAGA,
    GET_SUBSCRIPTION_DURATION_SAGA,
    GET_SUBSCRIPTION_WORKOUT_SAGA,
    GET_SUBSCRIPTION_CONSTRAINT_SAGA,
    REMOVE_SUBSCRIPTION_TYPE_SAGA,
    REMOVE_SUBSCRIPTION_DURATION_SAGA,
    REMOVE_SUBSCRIPTION_WORKOUT_SAGA,
    REMOVE_SUBSCRIPTION_CONSTRAINT_SAGA,
    REMOVE_SUBSCRIPTION_SAGA,
    GET_DATA_FOR_QR_SAGA,
    SEND_MESSAGES_SAGA,
    GET_USER_INFO_SAGA,
    GET_USERS_STATISTIC_SAGA,
    ACTIVATION_SUBSCRIPTION_SAGA,
    SAVE_KEY_NUMBER_SAGA,
    FIND_KEY_NUMBER_SAGA,
    GET_WORKOUTS_FROM_CERTAIN_SUBSCRIPTION_SAGA,
    GET_PROMO_SAGA,
    UPDATE_PROMO_SAGA,
    REMOVE_PROMO_SAGA,
    SET_QR_SETTINGS_SAGA,
    GET_PRICE_SAGA,
    UPDATE_PRICE_SAGA,
    REMOVE_PRICE_SAGA,
    GET_COACHES_SAGA,
    UPDATE_COACH_SAGA,
    REMOVE_COACH_SAGA,
    RECORD_ONE_TIME_WORKOUT_SAGA,
    GET_SALES_SAGA,
    GET_COST_SAGA,
    EXPORT_SALES_TO_EXCEL_SAGA,
    COPY_SUBSCRIPTION_SAGA,
    GET_PAYMENT_METHOD_SAGA,
    REMOVE_PAYMENT_METHOD_SAGA,
    UPDATE_PAYMENT_SAGA,
    REMOVE_PAYMENT_SAGA,
    REPAY_MONEY_FOR_SUBSCRIPTION_SAGA,
    UPDATE_BOOKING_SAGA,
    REMOVE_BOOKING_SAGA,
    GET_BOOKING_USERS_SAGA,
    ADD_USER_TO_BOOKING_SAGA,
    REMOVE_USER_FROM_BOOKING_SAGA,
    GET_SUBSCRIPTION_INACTIVE_DAYS_SAGA,
    UPDATE_SUBSCRIPTION_INACTIVE_DAYS_SAGA,
    CHANGE_WORKOUT_COACH_SAGA,
    GET_FAMILY_LIST_SAGA,
    UPDATE_SUBSCRIPTION_FAMILY_LIST_SAGA,
    REMOVE_WORKOUT_SAGA,
    CHANGE_WORKOUT_TYPE_SAGA,
    GET_DISCOUNT_SAGA,
    REMOVE_DISCOUNT_SAGA,
    UPDATE_DISCOUNT_SAGA,
    GET_GIFTS_SAGA,
    GET_GIFT_BY_ID,
    REMOVE_GIFT_SAGA,
    UPDATE_GIFT_SAGA,
    GET_GIFTS_ORDERS_SAGA,
    ACTION_GIFT_ORDER_SAGA,
    UPDATE_WORKOUT_COST_SAGA,
    GET_GOODS_SAGA,
    UPDATE_GOODS_SAGA,
    GET_GOODS_BY_ID_SAGA,
    REMOVE_GOODS_SAGA,
    GET_GROUPS_SAGA,
    UPDATE_GROUP_SAGA,
    GET_GROUP_BY_ID_SAGA,
    REMOVE_GROUP_SAGA,
    SAVE_GOODS_PURCHASE_SAGA,
    COPY_BOOKING_SAGA,
    COPY_DAY_BOOKING_SAGA,
    GET_WEEK_BOOKING_SAGA,
    SAVE_WEB_TOKEN_SAGA,
    EXPORT_USERS_TO_EXCEL_SAGA,
    UPDATE_TASK_SAGA,
    GET_TASKS_SAGA,
    GET_TASK_BY_ID_SAGA,
    REMOVE_TASK_SAGA,
    ARCHIVE_TASK_SAGA,
    COPY_WEEK_BOOKING_SAGA,
    TRANSFER_USER_DATA_SAGA,
    SET_USER_PERMISSION_SAGA,
    GET_USER_PERMISSION_SAGA,
    SEND_BOOKING_NOTIFICATION_SAGA,
    CHANGE_WORKOUT_DATE_SAGA,
    CHANGE_PAYMENT_DATE_SAGA,
    FREEZE_SUBSCRIPTION_SAGA,
    REMOVE_DEBT_WORKOUT_SAGA,
    SORT_SAGA,
    CONFIRM_EMAIL_SAGA,
    CANCEL_BOOKING_SAGA,
    GET_PROMO_GOODS_SAGA,
    UPDATE_PROMO_GOODS_SAGA,
    UPLOAD_FILE_SAGA,
    REMOVE_MISSED_WORKOUT_SAGA,
    DEACTIVATE_SUBSCRIPTION_SAGA,
    SET_USER_SETTINGS_SAGA,
    GET_AUTOMATION_SAGA,
    UPDATE_BIRTHDAY_AUTOMATION_SAGA,
    REMOVE_BIRTHDAY_AUTOMATION_SAGA,
    GET_ADMIN_BY_ID_SAGA,
    UPDATE_ADMIN_BY_ID_SAGA,
    REMOVE_ADMIN_BY_ID_SAGA,
    GET_DEPOSIT_LIST_SAGA,
    UPDATE_DEPOSIT_SAGA,
    GET_DEPOSIT_BY_ID_SAGA,
    REMOVE_DEPOSIT_SAGA,
    WORKOUT_PAYMENT_SAGA,
    RESET_ADMIN_PASSWORD_SAGA,
    CHANGE_UNLIM_SUBSCRIPTION_SAGA,
    UPDATE_GOODS_REST_SAGA,
    EXPORT_GOODS_REST_TO_EXCEL_SAGA,
    GET_SALARIES_DATA_SAGA,
    GET_LEADERBOARD_SAGA,
    GET_AVAILABLE_SUBSCRIPTIONS_SAGA,
    ADD_WORKOUT_BY_AVAILABLE_SUBSCRIPTION_SAGA,
    GET_LAST_BOOKING_SAGA,
    GET_CHILDREN_SAGA,
    GET_CHILD_BY_ID_SAGA,
    UPDATE_CHILD_SAGA,
    REMOVE_CHILD_SAGA,
    GET_REVIEWS_SAGA,
    GENERATE_INVOICE_SAGA
} from "./sagaTypes";

// Вход в систему
export const authSubmitSagaAction = data => ({ type: AUTH_SUBMIT_SAGA, data });
// Проверка токена
export const checkTokenSagaAction = data => ({ type: CHECK_TOKEN_SAGA, data });
// Получение текущих посетителей зала
export const currentVisitorsSagaAction = data => ({ type: CURRENT_VISITORS_SAGA, data });
// Получение списка заведений
export const establishmentListSagaAction = () => ({ type: ESTABLISHMENT_LIST_SAGA });
// Завершаем тренировку посетителя
export const closeWorkoutSagaAction = data => ({ type: CLOSE_WORKOUT_SAGA, data });
// Получение статистики
export const getStatisticSagaAction = data => ({ type: GET_STATISTIC_SAGA, data });
// Получение абонементов
export const getSubscriptionsSagaAction = data => ({ type: GET_SUBSCRIPTIONS_SAGA, data });
// Обновление абонемента
export const updateSubscriptionSagaAction = data => ({ type: UPDATE_SUBSCRIPTION_SAGA, data });
// Обновление посетителя
export const updateUserSagaAction = data => ({ type: UPDATE_USER_SAGA, data });
// Удаление посетителя
export const removeUserSagaAction = data => ({ type: REMOVE_USER_SAGA, data });
// Получение списка посетителей, у которых есть совпадение в номере телефона или email (создание нового абонемента)
export const getUsersForSubscriptionSagaAction = data => ({ type: GET_USERS_FOR_SUBSCRIPTION_FORM_SAGA, data });
// Получение текущего года и типов занятий для формы добавления абонемента
export const getSubscriptionDataSagaAction = data => ({ type: GET_SUBSCRIPTION_DATA, data });
// Добавление нового абонемента
export const addSubscriptionSagaAction = data => ({ type: ADD_SUBSCRIPTION_SAGA, data });
// Обновление информации о заведении
export const updateEstablishmentSagaAction = data => ({ type: UPDATE_ESTABLISHMENT_SAGA, data });
// Обновление (добавление) типа абонемента
export const updateSubscriptionTypeSagaAction = data => ({ type: UPDATE_SUBSCRIPTION_TYPE_SAGA, data });
// Обновление (добавление) продолжительности абонемента
export const updateSubscriptionDurationSagaAction = data => ({ type: UPDATE_SUBSCRIPTION_DURATION_SAGA, data });
// Обновление (добавление) количества занятий абонемента
export const updateSubscriptionWorkoutsSagaAction = data => ({ type: UPDATE_SUBSCRIPTION_WORKOUTS_SAGA, data });
// Обновление (добавление) ограничения
export const updateSubscriptionConstraintSagaAction = data => ({ type: UPDATE_SUBSCRIPTION_CONSTRAINT_SAGA, data });
// Запрашиваем данные для типа абонемента
export const getSubscriptionTypeSagaAction = data => ({ type: GET_SUBSCRIPTION_TYPE_SAGA, data });
// Запрашиваем данные для срока действия абонемента
export const getSubscriptionDurationSagaAction = data => ({ type: GET_SUBSCRIPTION_DURATION_SAGA, data });
// Запрашиваем данные для количества занятий в абонементе
export const getSubscriptionWorkoutsSagaAction = data => ({ type: GET_SUBSCRIPTION_WORKOUT_SAGA, data });
// Запрашиваем данные для ограничения
export const getSubscriptionConstraintSagaAction = data => ({ type: GET_SUBSCRIPTION_CONSTRAINT_SAGA, data });
// Удаление типа абонемента
export const removeSubscriptionTypeSagaAction = data => ({ type: REMOVE_SUBSCRIPTION_TYPE_SAGA, data });
// Удаление срока действия абонемента
export const removeSubscriptionDurationSagaAction = data => ({ type: REMOVE_SUBSCRIPTION_DURATION_SAGA, data });
// Удаление количества занятий
export const removeSubscriptionWorkoutSagaAction = data => ({ type: REMOVE_SUBSCRIPTION_WORKOUT_SAGA, data });
// Удаление ограничения
export const removeSubscriptionConstraintSagaAction = data => ({ type: REMOVE_SUBSCRIPTION_CONSTRAINT_SAGA, data });
// Удаление абонемента
export const removeSubscriptionSagaAction = data => ({ type: REMOVE_SUBSCRIPTION_SAGA, data });
// Получение данных для qr-кода
export const getDataForQRSagaAction = data => ({ type: GET_DATA_FOR_QR_SAGA, data });
// Рассылка сообщений пользователям
export const sendMessagesSagaAction = data => ({ type: SEND_MESSAGES_SAGA, data });
// Получение полной информации о конкретном пользователе
export const getUserInfoSagaAction = data => ({ type: GET_USER_INFO_SAGA, data });
// Получение статистики по пользователям
export const getUsersStatisticSagaAction = data => ({ type: GET_USERS_STATISTIC_SAGA, data });
// Активация абонемента
export const activationSubscriptionSagaAction = data => ({ type: ACTIVATION_SUBSCRIPTION_SAGA, data });
// Сохранение номера ключа (от шкафа)
export const saveKeyNumberSagaAction = data => ({ type: SAVE_KEY_NUMBER_SAGA, data });
// Поиск пользователя, у которого был ключ
export const findKeyNumberSagaAction = data => ({ type: FIND_KEY_NUMBER_SAGA, data });
// Получение списка тренировок по указанному абонементу
export const getWorkoutsFromCertainSubscriptionSagaAction = data => ({ type: GET_WORKOUTS_FROM_CERTAIN_SUBSCRIPTION_SAGA, data });
// Получение списка акций
export const getPromoSagaAction = data => ({ type: GET_PROMO_SAGA, data });
// Добавление / обновление акции
export const updatePromoSagaAction = data => ({ type: UPDATE_PROMO_SAGA, data });
// Удаление акции
export const removePromoSagaAction = data => ({ type: REMOVE_PROMO_SAGA, data });
// Сохранение настроек для QR-кода заведения
export const setQRSettingsSagaAction = data => ({ type: SET_QR_SETTINGS_SAGA, data });
// Получение цен
export const getPriceSagaAction = data => ({ type: GET_PRICE_SAGA, data });
// Добавление / обновление цены
export const updatePriceSagaAction = data => ({ type: UPDATE_PRICE_SAGA, data });
// Удаление цены
export const removePriceSagaAction = data => ({ type: REMOVE_PRICE_SAGA, data });
// Получение списка тренеров
export const getCoachesSagaAction = data => ({ type: GET_COACHES_SAGA, data });
// Добавление / обновление тренера
export const updateCoachSagaAction = data => ({ type: UPDATE_COACH_SAGA, data });
// Удаление тренера
export const removeCoachSagaAction = data => ({ type: REMOVE_COACH_SAGA, data });
// Запись разового посещения
export const recordOneTimeWorkoutSagaAction = data => ({ type: RECORD_ONE_TIME_WORKOUT_SAGA, data });
// Получение списка продаж
export const getSalesSagaAction = data => ({ type: GET_SALES_SAGA, data });
// Получение цены
export const getCostSagaAction = data => ({ type: GET_COST_SAGA, data });
// Получение продаж в excel файле
export const exportSalesToExcelSagaAction = data => ({ type: EXPORT_SALES_TO_EXCEL_SAGA, data });
// Копирование абонемента (создание нового)
export const copySubscriptionSagaAction = data => ({ type: COPY_SUBSCRIPTION_SAGA, data });
// Получение данный для метода оплаты
export const getPaymentMethodSagaAction = data => ({ type: GET_PAYMENT_METHOD_SAGA, data });
// Удаление метода оплаты
export const removePaymentMethodSagaAction = data => ({ type: REMOVE_PAYMENT_METHOD_SAGA, data });
// Редактирование платежа
export const updatePaymentSagaAction = data => ({ type: UPDATE_PAYMENT_SAGA, data });
// Удаление платежа
export const removePaymentSagaAction = data => ({ type: REMOVE_PAYMENT_SAGA, data });
// Возврат средств за абонемент
export const repayMoneyForSubscriptionSagaAction = data => ({ type: REPAY_MONEY_FOR_SUBSCRIPTION_SAGA, data });
// Добавление / обновление новой записи
export const updateBookingSagaAction = data => ({ type: UPDATE_BOOKING_SAGA, data });
// Удаление записи
export const removeBookingSagaAction = data => ({ type: REMOVE_BOOKING_SAGA, data });
// Получение списка пользователей для указанной записи
export const getBookingUsersSagaAction = data => ({ type: GET_BOOKING_USERS_SAGA, data });
// Добавляем пользователя в запись
export const addUserToBookingSagaAction = data => ({ type: ADD_USER_TO_BOOKING_SAGA, data });
// Удаление пользователя из записи
export const removeUserFromBookingSagaAction = data => ({ type: REMOVE_USER_FROM_BOOKING_SAGA, data });
// Получаем срок действия неактивированного абонемента
export const getSubscriptionInactiveDaysSagaAction = data => ({ type: GET_SUBSCRIPTION_INACTIVE_DAYS_SAGA, data });
// Обновление срока действия неактивированных абонементов
export const updateSubscriptionInactiveDaysSagaAction = data => ({ type: UPDATE_SUBSCRIPTION_INACTIVE_DAYS_SAGA, data });
// Смена тренера в тренеровке
export const changeWorkoutCoachSagaAction = data => ({ type: CHANGE_WORKOUT_COACH_SAGA, data });
// Получение списка участников семейного абонемента
export const getFamilyListSagaAction = data => ({ type: GET_FAMILY_LIST_SAGA, data });
// Обновление участников семейного абонемента
export const updateSubscriptionFamilyListSagaAction = data => ({ type: UPDATE_SUBSCRIPTION_FAMILY_LIST_SAGA, data });
// Удаление тренировки
export const removeWorkoutSagaAction = data => ({ type: REMOVE_WORKOUT_SAGA, data });
// Смена типа тренировки на странице с тренировками
export const changeWorkoutTypeSagaAction = data => ({ type: CHANGE_WORKOUT_TYPE_SAGA, data });
// Получение информации о скидке
export const getDiscountSagaAction = data => ({ type: GET_DISCOUNT_SAGA, data });
// Добавление / удаление скидки
export const updateDiscountSagaAction = data => ({ type: UPDATE_DISCOUNT_SAGA, data });
// Удаление скидки
export const removeDiscountSagaAction = data => ({ type: REMOVE_DISCOUNT_SAGA, data });
// Получение списка бонусов
export const getGiftsSagaAction = data => ({ type: GET_GIFTS_SAGA, data });
// Получение бонуса по id
export const getGiftByIdSagaAction = data => ({ type: GET_GIFT_BY_ID, data });
// Обновление / добавление бонуса
export const updateGiftSagaAction = data => ({ type: UPDATE_GIFT_SAGA, data });
// Удаление бонуса
export const removeGiftSagaAction = data => ({ type: REMOVE_GIFT_SAGA, data });
// Получение списка заказанных бонусов
export const getGiftsOrdersSagaAction = data => ({ type: GET_GIFTS_ORDERS_SAGA, data });
// Подтверждение / отклонение заказа бонуса
export const actionGiftOrderSagaAction = data => ({ type: ACTION_GIFT_ORDER_SAGA, data });
// Редактирование стоимости тренировки
export const updateWorkoutCostSagaAction = data => ({ type: UPDATE_WORKOUT_COST_SAGA, data });
// Получение списка товаров
export const getGoodsSagaAction = data => ({ type: GET_GOODS_SAGA, data });
// Добавление / обновление товара
export const updateGoodsSagaAction = data => ({ type: UPDATE_GOODS_SAGA, data });
// Получение товара по id
export const getGoodsByIdSagaAction = data => ({ type: GET_GOODS_BY_ID_SAGA, data });
// Удаление товара
export const removeGoodsSagaAction = data => ({ type: REMOVE_GOODS_SAGA, data });
// Получение списка групп товаров
export const getGroupsSagaAction = data => ({ type: GET_GROUPS_SAGA, data });
// Добавление / обновление группы товаров
export const updateGroupSagaAction = data => ({ type: UPDATE_GROUP_SAGA, data });
// Получение группы по id
export const getGroupByIdSagaAction = data => ({ type: GET_GROUP_BY_ID_SAGA, data });
// Удаление группы
export const removeGroupSagaAction = data => ({ type: REMOVE_GROUP_SAGA, data });
// Сохранение продажи товара
export const saveGoodsPurchaseSagaAction = data => ({ type: SAVE_GOODS_PURCHASE_SAGA, data });
// Копирование записи на несколько дней
export const copyBookingSagaAction = data => ({ type: COPY_BOOKING_SAGA, data });
// Копирование записей дня
export const copyDayBookingSagaAction = data => ({ type: COPY_DAY_BOOKING_SAGA, data });
// Получение записей на неделю
export const getWeekBookingSagaAction = data => ({ type: GET_WEEK_BOOKING_SAGA, data });
// Сохранение токена для оповещений
export const saveWebTokenSagaAction = data => ({ type: SAVE_WEB_TOKEN_SAGA, data });
// Выгрузка клиентской базы в excel
export const exportUsersToExcelSagaAction = data => ({ type: EXPORT_USERS_TO_EXCEL_SAGA, data });
// Добавление / обновление задачи
export const updateTaskSagaAction = data => ({ type: UPDATE_TASK_SAGA, data });
// Получение списка задач
export const getTasksSagaAction = data => ({ type: GET_TASKS_SAGA, data });
// Получение задачи по id
export const getTaskByIdSagaAction = data => ({ type: GET_TASK_BY_ID_SAGA, data });
// Удаление задачи
export const removeTaskSagaAction = data => ({ type: REMOVE_TASK_SAGA, data });
// Перемещение задачи в архив
export const archiveTaskSagaAction = data => ({ type: ARCHIVE_TASK_SAGA, data });
// Копирывание недели с записями
export const copyWeekBookingSagaAction = data => ({ type: COPY_WEEK_BOOKING_SAGA, data });
// Перенос данных пользователя по номеру телефона
export const transferUserDataSagaAction = data => ({ type: TRANSFER_USER_DATA_SAGA, data });
// Редактирование прав пользователя
export const setUserPermissionSagaAction = data => ({ type: SET_USER_PERMISSION_SAGA, data });
// Получение прав пользователя
export const getUserPermissionSagaAction = data => ({ type: GET_USER_PERMISSION_SAGA, data });
// Отправка уведомлений в записи
export const sendBookingNotificationSagaAction = data => ({ type: SEND_BOOKING_NOTIFICATION_SAGA, data });
// Смена даты тренировки
export const changeWorkoutDateSagaAction = data => ({ type: CHANGE_WORKOUT_DATE_SAGA, data });
// Смена даты продажи
export const changePaymentDateSagaAction = data => ({ type: CHANGE_PAYMENT_DATE_SAGA, data });
// Заморозка абонемента
export const freezeSubscriptionSagaAction = data => ({ type: FREEZE_SUBSCRIPTION_SAGA, data });
// Удаление тренировки в долг
export const removeDebtWorkoutSagaAction = data => ({ type: REMOVE_DEBT_WORKOUT_SAGA, data });
// Сортировка данных
export const sortSagaAction = data => ({ type: SORT_SAGA, data });
// Подтверждение почты
export const confirmEmailSagaAction = data => ({ type: CONFIRM_EMAIL_SAGA, data });
// Отмена группового занятия
export const cancelBookingSagaAction = data => ({ type: CANCEL_BOOKING_SAGA, data });
// Получение списка товаров для настройки промокода
export const getPromoGoodsSagaAction = data => ({ type: GET_PROMO_GOODS_SAGA, data });
// Обновление списка товаров в настройках промокода
export const updatePromoGoodsSagaAction = data => ({ type: UPDATE_PROMO_GOODS_SAGA, data });
// Загрузка файла (документа)
export const uploadFileSagaAction = data => ({ type: UPLOAD_FILE_SAGA, data });
// Удаление пропущенной тренировки
export const removeMissedWorkoutSagaAction = data => ({ type: REMOVE_MISSED_WORKOUT_SAGA, data });
// Деактивация абонемента
export const deactivateSubscriptionSagaAction = data => ({ type: DEACTIVATE_SUBSCRIPTION_SAGA, data });
// Сохранение настроек пользователя
export const setUserSettingsSagaAction = data => ({ type: SET_USER_SETTINGS_SAGA, data });
// Получение настроек автоматизации
export const getAutomationSagaAction = data => ({ type: GET_AUTOMATION_SAGA, data });
// Сохранение настроек автоматизации (день рождения)
export const updateBirthdayAutomationSagaAction = data => ({ type: UPDATE_BIRTHDAY_AUTOMATION_SAGA, data });
// Удаление автоматического поздравления именинников
export const removeBirthdayAutomationSagaAction = data => ({ type: REMOVE_BIRTHDAY_AUTOMATION_SAGA, data });
// Получение администратора по id
export const getAdminByIdSagaAction = data => ({ type: GET_ADMIN_BY_ID_SAGA, data });
// Обновление администратора по id
export const updateAdminByIdSagaAction = data => ({ type: UPDATE_ADMIN_BY_ID_SAGA, data });
// Удаление администратора
export const removeAdminByIdSagaAction = data => ({ type: REMOVE_ADMIN_BY_ID_SAGA, data });
// Получение списка операций по депозиту
export const getDepositListSagaAction = data => ({ type: GET_DEPOSIT_LIST_SAGA, data });
// Обновление депозита
export const updateDepositSagaAction = data => ({ type: UPDATE_DEPOSIT_SAGA, data });
// Получение депозита по id
export const getDepositByIdSagaAction = data => ({ type: GET_DEPOSIT_BY_ID_SAGA, data });
// Удаление депозита
export const removeDepositSagaAction = data => ({ type: REMOVE_DEPOSIT_SAGA, data });
// Доплата за тренировку
export const workoutPaymentSagaAction = data => ({ type: WORKOUT_PAYMENT_SAGA, data });
// Сброс пароля администратору (суперадмином)
export const resetAdminPasswordSagaAction = data => ({ type: RESET_ADMIN_PASSWORD_SAGA, data });
// Сделать абонемент безлимитным / убрать безлимит
export const changeUnlimSubscriptionSagaAction = data => ({ type: CHANGE_UNLIM_SUBSCRIPTION_SAGA, data });
// Смена количества товара на складе
export const updateGoodsRestSagaAction = data => ({ type: UPDATE_GOODS_REST_SAGA, data });
// Выгрузка остатков в excel
export const exportGoodsRestToExcelSagaAction = data => ({ type: EXPORT_GOODS_REST_TO_EXCEL_SAGA, data });
// Получение данных о зарплатах
export const getSalariesDataSagaAction = data => ({ type: GET_SALARIES_DATA_SAGA, data });
// Получение таблицы лидеров
export const getLeaderboardSagaAction = data => ({ type: GET_LEADERBOARD_SAGA, data });
// Получение списка доступных абонементов для списания группового занятия
export const getAvailableSubscriptionsSagaAction = data => ({ type: GET_AVAILABLE_SUBSCRIPTIONS_SAGA, data });
// Списание тренировки на групповое занятие из доступных абонементов
export const addWorkoutByAvailableSubscriptionSagaAction = data => ({ type: ADD_WORKOUT_BY_AVAILABLE_SUBSCRIPTION_SAGA, data });
// Получение списка последних записей пользователя
export const getLastBookingSagaAction = data => ({ type: GET_LAST_BOOKING_SAGA, data });
// Получение списка детей
export const getChildrenSagaAction = data => ({ type: GET_CHILDREN_SAGA, data });
// Получение ребёнка по id
export const getChildByIdSagaAction = data => ({ type: GET_CHILD_BY_ID_SAGA, data });
// Обновление ребёнка
export const updateChildSagaAction = data => ({ type: UPDATE_CHILD_SAGA, data });
// Удаление записе о ребёнке
export const removeChildSagaAction = data => ({ type: REMOVE_CHILD_SAGA, data });
// Получение списка отзывов за период
export const getReviewsSagaAction = data => ({ type: GET_REVIEWS_SAGA, data });
// Генерация счёта
export const generateInvoiceSagaAction = data => ({ type: GENERATE_INVOICE_SAGA, data });